// ========= START: src/components/AvatarDisplay.js (Complete File) =========
import React, { useState, useEffect, useRef } from 'react';

const getRandomVideo = (videoList) => {
  if (!videoList || videoList.length === 0) return null;
  return videoList[Math.floor(Math.random() * videoList.length)];
};

function AvatarDisplay({ botState, activeCharacter }) {
  const videoRef = useRef(null);
  const [videoSrc, setVideoSrc] = useState(getRandomVideo(activeCharacter.idleVideos));

 useEffect(() => {
    let newVideoSrc;
    if (botState === 'idle') {
      newVideoSrc = getRandomVideo(activeCharacter.idleVideos);
    } else { // 'talking'
      newVideoSrc = getRandomVideo(activeCharacter.talkingVideos);
    }
    setVideoSrc(newVideoSrc);
  }, [botState, activeCharacter]);

  const handleVideoEnded = () => {
    const list = botState === 'idle' ? activeCharacter.idleVideos : activeCharacter.talkingVideos;
    // Exclude the video that just ended so React sees a new src, re-mounts
    // the element, and the animation never freezes on a same-URL re-pick.
    const pool = list.filter(v => v !== videoSrc);
    setVideoSrc(pool.length > 0 ? pool[Math.floor(Math.random() * pool.length)] : list[0]);
  };

  return (
    <div 
      className="avatar-container" 
      style={{ 
        backgroundImage: `url("${process.env.PUBLIC_URL}/assets/backgrounds/avatar-bp.jpeg")`, 
        backgroundSize: 'cover', 
        backgroundPosition: 'center', 
        backgroundColor: 'transparent' 
      }}
    >
      {videoSrc && (
        <video
          ref={videoRef}
          key={videoSrc}
          className="avatar-video"
          src={videoSrc}
          autoPlay
          muted
          playsInline
          onEnded={handleVideoEnded}
        />
      )}
    </div>
  );
}

export default AvatarDisplay;
// ========= END: src/components/AvatarDisplay.js (Complete File) =========